// Copyright (c) Microsoft Corporation.
// Licensed under the MIT License.

import { MoreHorizontal20Filled } from '@fluentui/react-icons';
import { ControlBarButton } from '@azure/communication-react';

const icon = () => <MoreHorizontal20Filled key={'chatOnIconKey'} primaryFill="currentColor" />;

/**
 * @private
 */
export const MoreButton = (props) => {


  return (
    <ControlBarButton
      {...props}
      labelKey={'optionsButtonLabelKey'} 
      showLabel={props.showLabel}
      onRenderOnIcon={icon}
      onRenderOffIcon={icon}
      onClick={props.onClick}
      data-ui-id={props['data-ui-id']}
    />
  );
};
